import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PhetEmbedDialogData {
  phetUrl: string;
}

@Component({
  selector: 'app-phet-embed-dialog',
  templateUrl: './phet-embed.component.html',
  styleUrls: ['./phet-embed.component.scss'],
})
export class PhetEmbedDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: PhetEmbedDialogData) {}
}
